<template>
  <tabs parent="notification">
    <tab
      id="profiles"
      :name="translate('notification.dev_notify')"
      :href="url+'/profiles'"
    >
      <notification-profile />
    </tab>

    <tab
        id="traffic_notification"
        :name="translate('notification.traffic')"
        :href="url+'/traffic_notification'"
        :isVisible="this.$store.getters.getPermissions.viewDeviceTrafficAlerts === true"
    >
      <traffic-notification />
    </tab>

    <tab
      id="settings"
      :name="translate('notification.settings')"
      :href="url+'/settings'"
    >
      <settings />
    </tab>


  </tabs>
</template>

<script>
import Settings from './Notification/TabSettings'
import NotificationProfile from "./Notification/TabProfile";
import TrafficNotification from "./Notification/TabTrafficNotification";

import {Tabs, Tab} from 'components/UIComponents/Tabs'

export default {
  name: 'Notification',
  components: {
    Tabs,
    Tab,
    Settings,
    NotificationProfile,
    TrafficNotification
  },
  computed: {
    url () { return '/notification' }
  },
}
</script>
